// This file define the custom validator that is used on the client side to evaluate Character Set text validation rules
// The logic in here should produce identical results to the logic in CharacterSetValidator.cs

import { TEXT_VALIDATION_RULE_CHAR_SETS } from "./textValidationRulesTab.vue";
import * as validationHelpers from "./textValidationRuleValidationHelpers";

export function validate(value, ruleSchema) {
    if (value === null || value === "") {
        return true;
    }

    if (doesInputExceedMaxLength(value, ruleSchema.maxLength)) {
        return false;
    }

    for (const ch of value) {
        if (
            !matchesAtLeastOneAllowedCharacterSet(ch, ruleSchema.allowedCharacterSets) &&
            !validationHelpers.isWhitespace(ch)
        ) {
            return false;
        }
    }

    return true;
}

function matchesAtLeastOneAllowedCharacterSet(inputChar, allowedCharacterSets) {
    for (const charSet of allowedCharacterSets) {
        if (charIsInSet(inputChar, charSet)) {
            return true;
        }
    }
    return false;
}

function charIsInSet(inputChar, charSet) {
    switch (charSet) {
        case TEXT_VALIDATION_RULE_CHAR_SETS.A_Z_UPPER:
            return validationHelpers.isUppercaseLetter(inputChar);
        case TEXT_VALIDATION_RULE_CHAR_SETS.A_Z_LOWER:
            return validationHelpers.isLowercaseLetter(inputChar);
        case TEXT_VALIDATION_RULE_CHAR_SETS.NUMERIC:
            return validationHelpers.isNumericDigit(inputChar);
        case TEXT_VALIDATION_RULE_CHAR_SETS.PUNCTUATION:
            return validationHelpers.isInPunctuationSet(inputChar);
    }
}

function doesInputExceedMaxLength(input, maxLength) {
    if (!maxLength || isNaN(maxLength) || maxLength === 0) {
        return false;
    }

    return input.length > maxLength;
}
